function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 16,
  rx: 2,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 16,
  rx: 2,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_239_33446)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 16,
  fill: "#0A17A7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.72032 10.6666L-2.37744 15.7645L-1.09929 17.5331L9.14283 11.0853V17.0666H14.8571V11.0853L25.0992 17.5331L26.3774 15.7645L18.2796 10.6666H24V5.33329H18.2796L26.3774 0.23541L25.0992 -1.5332L14.8571 4.91463V-1.06671H9.14283V4.91463L-1.09929 -1.5332L-2.37744 0.235414L5.72033 5.33329H-2.71797e-05V10.6666H5.72032Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.001 5.06578L26.857 -1.59998",
  stroke: "#DB1F35",
  strokeWidth: 0.666667,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.1538 10.958L26.8857 17.0803",
  stroke: "#DB1F35",
  strokeWidth: 0.666667,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.8621 5.04836L-3.28906 -1.33679",
  stroke: "#DB1F35",
  strokeWidth: 0.666667,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.9631 10.8839L-3.28906 17.8484",
  stroke: "#DB1F35",
  strokeWidth: 0.666667,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 9.6H10.2857V16H13.7143V9.6H24V6.4H13.7143V0H10.2857V6.4H0V9.6Z",
  fill: "#E6273E"
}));

function SvgGb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_239_33446",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _ref3), _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/GB.1829a111.svg";
export { ForwardRef as ReactComponent };